import { fromJS } from 'immutable';
import * as ACTIONS from '../containers/constants';

const initialState = fromJS({});

export function mailboxReducer(state = initialState, action) {

  switch (action.type) {
    case ACTIONS.MAILBOX_GET_UPDATE:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
}

export default mailboxReducer;
